import { Stack, Typography } from "@mui/material"
import CircleIcon from "@mui/icons-material/Circle"
import { ChartsTooltipContainer, useAxesTooltip } from "@mui/x-charts"
import { DateTime } from "luxon"
import { useTranslation } from "react-i18next"

import { ICE_TYPES_BY_SEVERITY } from "helpers/utils/icing"
import ChartTooltipCard from "widgets/plots/mui/ChartTooltipCard"

interface MuiIcingTooltipProps {
  trigger?: "axis" | "item" | "none" | undefined
}

const MuiIcingTooltip = ({ trigger }: MuiIcingTooltipProps) => {
  const { t } = useTranslation()
  const axes = useAxesTooltip()

  // Tooltip only for X axes, one axis of type "_time"
  // Not handling multiple axes or multiple time axes
  // Also not handling trigger "item"
  const timeAxis = axes !== null && axes[0].axisId === "_time" ? axes[0] : null

  const formattedDate = timeAxis?.axisValue
    ? DateTime.fromJSDate(timeAxis.axisValue as Date).toFormat("yyyy-MM-dd HH:mm")
    : ""

  // Find the series item that has a non-null value
  const seriesItemWithValue = timeAxis?.seriesItems?.find((item) => item.value !== null)
  const severityValue = seriesItemWithValue?.value as number | null

  const iceType =
    severityValue !== null ? ICE_TYPES_BY_SEVERITY[severityValue] : undefined

  return (
    <ChartsTooltipContainer trigger={trigger}>
      {trigger === "axis" && timeAxis && iceType && (
        <ChartTooltipCard title={formattedDate}>
          <Stack>
            <Stack direction="row" alignItems="center" gap={1}>
              <CircleIcon sx={{ fontSize: 8, color: iceType.color }} />
              <Typography variant="body2">
                {t("plots_tooltip.TYPE")}: {t(iceType.labelKey)}
              </Typography>
            </Stack>
            <Typography variant="body2" pl={2}>
              {t("plots_tooltip.SEVERITY")}: {iceType.severity}
            </Typography>
          </Stack>
        </ChartTooltipCard>
      )}
    </ChartsTooltipContainer>
  )
}

export default MuiIcingTooltip
